import { render, staticRenderFns } from "./Step4Confirm.vue?vue&type=template&id=0c5377c4&scoped=true"
import script from "./Step4Confirm.vue?vue&type=script&lang=js"
export * from "./Step4Confirm.vue?vue&type=script&lang=js"
import style0 from "./Step4Confirm.vue?vue&type=style&index=0&id=0c5377c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5377c4",
  null
  
)

export default component.exports